
const Currency = {
    EUR : "€",
    USD : "$",
    XCD : "$",
    ARS : "$",
    AUD : "$",
    BSD : "$",
    BBD : "$",
    BZD : "$",
    BMD : "$",
    BES : "$",
    BND : "$",
    CAD : "$",
    KYD : "$",
    CLP : "$",
    COP : "$",
    NZD : "$",
    DOP : "$",
    FJD : "$",
    GYD : "$",
    HKD : "$",
    JMD : "$",
    LRD : "$",
    MXN : "$",
    NAD : "$",
    SBD : "$",
    SRD : "$",
    TTD : "$",
    UYU : "$",
    ZWL : "$",
    EGP : "£",
    FKP : "£",
    GIP : "£",
    GBP : "£",
    SHP : "£",
    SDG : "£",
    CNY : "¥",
    JPY : "¥"
};

function getCurrency(currencyString) {
    
    return Currency[currencyString]
}
  
export { Currency, getCurrency }
